import Input from "../design/Input";
import FetchMassage from '../../faetures/FetchMassage';
import Massage from "../design/Massage";
import { useState } from "react";
import regx from "../../functions/regx";


function ForgetPasspord({setForgetPasspord}) {
    const [sendEmail, setSendEmail] = useState(false);
    const [data, setData] = useState({email: "", passpordEmail: "", passpord: "", repetPasspord: ""});
    const [fetchMassage, setFetchMassage] = useState({open: false, data: '', text: "", url: ""});
    const [massage, setMassage] = useState({open: false, text: ""});

    const send = () => {
        if (sendEmail) {
            if (regx("passpord-login", data.passpord, false) && regx("passpord-login", data.repetPasspord, false)) {
                if (data.passpord !== data.repetPasspord) {
                    setMassage({open: true, text: "סיסמות לא זהות"});
                } else {
                    setFetchMassage({open: true, url: "login\\forgetPasswordEnd", text: "", data: 
                        {emailPassword: data.passpordEmail, password: data.passpord, passwordRepet: data.repetPasspord}
                    })
                }
            } else {
                setMassage({open: true, text: "סיסמה צריכה להכיל, לפחות אות גדולה אות קטנה מספר ותו מיוחד אחד. ולפחות 8 תווים"});
            }
        } else {
            if (regx("email", data.email, false)) {
                setFetchMassage({open: true, data:{email: data.email}, text: "", url: "login\\forgetPasswordFirst"});
            }
        }
    }


    const check_server_response = (resolve) => {
        if (resolve && resolve[0] == 'okay' && resolve["data"]) {
            setFetchMassage({open: true, text: resolve["data"]});
        } else {
            setFetchMassage({open: true, text: "שגיאה"}); 
        }

        if (!sendEmail && resolve && resolve[0]) {
            setSendEmail(true);
        }
    }

    return (
        <div>
            <p>איפוס סיסמה</p>

            <div>

                {
                    (! sendEmail) ?
                    <>
                        <div>
                            <label htmlFor="email">אמייל</label>
                            
                            <Input
                            name={"email"}
                            myStyle={'form-control'}
                            textView={"אמייל"}
                            pattern={"email"}
                            value={data.email}
                            onChange={(value) => setData({...data, email: value})}
                            language={"en"}
                            />
                        </div>

                    </> :
                    <>
                        <div>
                            <label htmlFor="password_email">סיסמה שנשלח לאמייל</label>

                            <Input
                            name={"password_email"}
                            textView={"סיסמה שנשלחה לאמייל"}
                            myStyle={"form-control"}
                            value={data.passpordEmail}
                            onChange={(value) => setData({...data, passpordEmail: value})}
                            />
                        </div>

                        <div>
                            <label htmlFor="password_new">סיסמה חדשה</label>

                            <Input
                            name={"password_new"}
                            textView={"סיסמה חדשה"}
                            myStyle={"form-control"}
                            value={data.passpord}
                            onChange={(value) => setData({...data, passpord: value})}
                            pattern={'passpord-login'}
                            />
                        </div>

                        <div>
                            <label htmlFor="repet_password">אימות סיסמה</label>

                            <Input
                            name={"repet_password"}
                            textView={"אימות סיסמה"}
                            myStyle={"form-control"}
                            value={data.repetPasspord}
                            onChange={(value) => setData({...data, repetPasspord: value})}
                            pattern={'passpord-login'}
                            />
                        </div>
                    </>
                }

                <p className={'forget-password-login'} onClick={() => setForgetPasspord(false)}>חזרה</p>

                <button 
                type="submit" 
                className="submit-button"
                onClick={send}
                > שליחה </button>

                {
                fetchMassage.open && 

                    <FetchMassage 
                    url={fetchMassage.url} 
                    data={fetchMassage.data} 
                    text={fetchMassage.text} 
                    fun={check_server_response}
                    setClose={() => setFetchMassage({open: false})}
                    setMassage={setFetchMassage}
                    />
                }

                {
                    massage.open &&
                    <Massage
                    text={massage.text}
                    setClose={() => setMassage({open: false})}
                    animation={true}
                    />
                }
            </div>
        </div>
    )
}


export default ForgetPasspord;